import { Heading } from '@simplywallst/ui-core';
import { Copy, ButtonLink } from './styled';
import DocumentHeader from '@/components/DocumentHeader';
import SkyscraperBackground from '@components/SkyscraperBackground';
import { useTracking } from 'react-tracking';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { redirect } from 'redux-first-router';
import type { Location } from 'redux-first-router';
import { useEffect } from 'react';
import { ROUTE_WELCOME } from '@/constants/routes';
import { useResendEmailValidation } from '@/hooks/useResendEmailValidation';

function maskEmail(email = '') {
  const [name, domain] = email.split('@');
  const maskedName = `${name[0]}...${name[name.length - 1]}`;
  const maskedEmail = `${maskedName}@${domain}`;
  return maskedEmail;
}

export function AccountValidation() {
  const dispatch = useDispatch();

  const { mutate: resendEmail, status: mutationStatus } =
    useResendEmailValidation();
  const accountInfo = useSelector<{ location: Location }, { email?: string }>(
    (state) => {
      if (
        typeof state.location.payload !== 'undefined' &&
        'email' in state.location.payload
      ) {
        return { email: state.location.payload.email };
      }
      return { email: undefined };
    },
    shallowEqual
  );
  const { email } = accountInfo;

  useEffect(() => {
    if (typeof email === 'undefined') {
      dispatch(redirect({ type: ROUTE_WELCOME }));
    }
  }, [email, dispatch]);

  const { Track } = useTracking({
    type: 'track',
    action: 'landed',
    subject: 'page',
  });

  if (typeof email === 'undefined') {
    return null;
  }
  return (
    <Track>
      <DocumentHeader
        title="Verify your email"
        allowCrawlers={false}
        allowFollow={false}
      />
      <SkyscraperBackground>
        <Heading as="h1" color="black">
          Verify your email
        </Heading>
        <Copy color="black" typography="base">
          Almost there! An email was sent to {maskEmail(email)}. You need to
          verify your email to log into Simply Wall St.
        </Copy>
        <Copy color="blackRGBA" opacity={0.4} typography="tiny">
          Haven't received your email yet? Check your spam folder or{' '}
          <ButtonLink
            styleType="strongLink"
            onClick={() => resendEmail(email)}
            disabled={mutationStatus === 'loading'}
            isLoading={mutationStatus === 'loading'}
            data-cy-id="resend-email"
          >
            resend email now
          </ButtonLink>
        </Copy>
      </SkyscraperBackground>
    </Track>
  );
}
